import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import Loading from 'components/generic/Loading'
import IFrameComponent from 'components/generic/embeds/IFrameComponent'
import { trackEvent } from 'utils/tracking'
import { CHURN_ZERO_EVENTS as cz, LOCALE_MAP } from 'utils/constants'
import { useGetMetabaseUrlQuery } from 'gen/rtk-openapi'

const DASHBOARDS = {
  'inbound-ticket-summary': {
    orgLevel: 20,
    yardLevel: 20, // we use this dashboard in the un-used Analytics page
  },
  'outbound-ticket-summary': {
    orgLevel: 21,
    yardLevel: 21, // we use this dashboard in the un-used Analytics page
  },
  'inbound-customer': {
    orgLevel: 'am1DXEb1wO',
    yardLevel: 36,
  },
}

const AnalyticsContainer = ({ dashboard, customParams, reportId }) => {
  const { yardId, locale } = useSelector(state => state.auth)
  const [embedUrl, setEmbedUrl] = useState(null)
  const hasPageLoaded = useRef(false)
  const {
    variables: { orgLevelReports },
  } = useSelector(state => state.featureFlags || {})
  const mbDashboardId = dashboard ? DASHBOARDS[dashboard][orgLevelReports ? 'orgLevel' : 'yardLevel'] : reportId
  if (dashboard) {
    customParams.reportType = 'EXPLO'
  }
  const { data: mbUrlData } = useGetMetabaseUrlQuery(
    { reportId: mbDashboardId, customParams: JSON.stringify(customParams) },
    { skip: !yardId },
  )

  // map the locale using LOCALE_MAP because explo doesn't support all locales yet
  const mappedLocale = LOCALE_MAP[locale]?.report || locale

  useEffect(() => {
    if (mbUrlData?.iframeUrl && mappedLocale)
      setEmbedUrl(`${mbUrlData?.iframeUrl}${mbUrlData.iframeUrl.includes('?') ? '&' : '?'}locale_code=${mappedLocale}`)
  }, [mbUrlData, mappedLocale])

  useEffect(() => {
    if (!hasPageLoaded.current) {
      trackEvent({
        eventName: cz.VIEW_ANALYTICS,
        description: dashboard || reportId,
      })
      hasPageLoaded.current = true
    }
  }, [dashboard, reportId])

  return (
    <Box style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
      {embedUrl ? <IFrameComponent title="Dashboard" src={embedUrl} /> : <Loading localized />}
    </Box>
  )
}

AnalyticsContainer.propTypes = {
  dashboard: PropTypes.string,
  customParams: PropTypes.object,
  reportId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

AnalyticsContainer.defaultProps = {
  dashboard: '',
  customParams: {},
  reportId: null,
}

export default AnalyticsContainer
